import React from 'react';
import { Allergen } from '@/contexts/item-context-types';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { getAllergenTranslation } from '@/utils/gtin-metadata';
import { Text, View } from 'react-native';

interface Props {
  allergens: Allergen[];
}

export const AllergenInfo: React.FC<Props> = ({ allergens }) => {
  const [styles] = useStyles();
  return (
    <View style={styles.base}>
      {allergens.map((allergen) => (
        <View key={allergen.name} style={styles.allergenItem}>
          <Text style={[TYPOGRAPHY.xsmall, FONTS.primarySemiBold]}>
            {getAllergenTranslation(allergen.name)}
          </Text>
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  allergenItem: {
    backgroundColor: theme.colors.allergen,
    borderRadius: 4,
    paddingHorizontal: 4,
    paddingVertical: 2,
  },
  base: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
}));
